export default "__VITE_ASSET__DOqmY5RL__"